/**
 * Created by Greg on 5/09/2016.
 */
import React from 'react';
import {Modal, Button, FormControl, FormGroup, Popover, OverlayTrigger} from 'react-bootstrap';
import { connect } from 'react-redux';
import {demandCollectionValidate} from './../../validation/demandValid';

var LoadDemandDialog = React.createClass({
    getInitialState() {
        return {value: "", demandObj: null, errors: null}
    },

    handleChange: function(event) {
        let temp = demandCollectionValidate(event.target.value);
        this.setState({value: event.target.value, demandObj: temp.demandObj, errors: temp.errors });
    },

    loadHandler() {
        if (!this.state.errors && this.state.demandObj) {
            this.props.loadDemand(this.state.demandObj);
        }
    },

    validationState() {
        if (this.state.errors) {
            return 'error';
        } else {
            return 'success';
        }
    },

    helpState() {
        if (this.state.errors) {
            return 'danger';
        } else {
            return 'info';
        }
    },

    helpPopover(){

        return (<Popover id="loadDemandHelpPopover" title="Load Demand Help">
            <p>This is where I'll give you some help and/or show you the errors if any.</p>
            <p>Errors:</p>
            <p>{JSON.stringify(this.state.errors)}</p>
        </Popover>)
    },

    render(){ return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="load-demand-modal">
            <Modal.Header closeButton>
                <Modal.Title>Load Demands JSON</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup validationState={this.validationState()}>
                <FormControl value={this.state.value} onChange={this.handleChange} componentClass="textarea"
                       placeholder="paste JSON here" rows={10} />
                    <FormControl.Feedback />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary" onClick={this.loadHandler} >Load </Button>
                <Button onClick={this.props.close} >Cancel</Button>
                <OverlayTrigger trigger="click" placement="top" overlay={this.helpPopover()}>
                    <Button bsStyle={this.helpState()}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showDemandLoadModal
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_DEMAND_LOAD_DIALOG'});
        },
        loadDemand: (demandObj) => {
            dispatch({type: "CLOSE_DEMAND_LOAD_DIALOG"});
            dispatch({type: 'DEMANDS_LOAD', demandObj: demandObj});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadDemandDialog)




// WEBPACK FOOTER //
// ./src/io/LoadDemandsDialog.js